module.exports = __webpack_public_path__ + "media/images/athletes/2786-d2ba59fae734c33b59bfe6b22e5da6a2.png";